import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import HomePage from './views/Home/home';
import Product from './views/Product/product';
import Subscription from './views/Subscription/subscription';
import Single from './views/Single/single';
import Company from './views/Company/company';
import Contact from './views/Contact/contact';
import Privacy from './views/Privacy/privacy';
import Terms from './views/Terms/terms';
import Regulation from './views/Regulation/regulation';
import Mypage from './views/Mypage/mypage';
import ProfileEdit from './views/Mypage/profile';
import AddressEdit from './views/Mypage/address';
import AddressAdd from './views/Mypage/addressAdd';
import UpdatePW from './views/Mypage/updatePw';
import ResetPW from './views/Mypage/resetPw';
import Cart from './views/Cart/cart';
import Apply from './views/Apply/apply';
import About from './views/About/about';
import Purchase from './views/Purchase/purchase';
import Login from './views/Login/login';
import Features from './views/Features/features';
import News from './views/News/news';
import NewsDetails from './views/News/detail';
import Testshop from './views/Testshop/testshop';
import ProductDetail from './views/Product/detail';
import Faq from './views/Faq/faq';
import Transaction from './views/Transaction/transaction';
import MasterCard from './views/MasterCard/MasterCard';
import Interview01 from './views/Interviews/interview01';
import Interview02 from './views/Interviews/interview02';
import Interview03 from './views/Interviews/interview03';
import Interview04 from './views/Interviews/interview04';

const Routes = () => (
  <BrowserRouter>
    <Switch>
      {/* Login  */}
      <Route path="/transaction">
        <Transaction />
      </Route>
      {/* Login  */}
      <Route path="/login">
        <Login />
      </Route>
      {/* 全ての商品 */}
      <Route exact path="/product">
        <Product />
      </Route>
      {/* 商品詳細 */}
      <Route path="/product/:page/:id">
        <ProductDetail />
      </Route>
      {/* 定期便 */}
      <Route path="/subscription">
        <Subscription />
      </Route>
      {/* 単品 */}
      <Route path="/single">
        <Single />
      </Route>
      {/* 会社概要 */}
      <Route path="/company">
        <Company />
      </Route>
      {/* お問い合わせ */}
      <Route path="/contact">
        <Contact />
      </Route>
      {/* 個人情報保護方針 */}
      <Route path="/privacy">
        <Privacy />
      </Route>
      {/* 利用規約  */}
      <Route path="/terms">
        <Terms />
      </Route>
      {/* 特定商取引法に基づく表記  */}
      <Route path="/regulation">
        <Regulation />
      </Route>
      {/* マイページ  */}
      <Route path="/mypage" exact>
        <Mypage />
      </Route>
      {/* お客様情報変更  */}
      <Route path="/mypage/profile/edit">
        <ProfileEdit />
      </Route>
      {/* お届け先変更  */}
      <Route path="/mypage/address/edit/:id">
        <AddressEdit />
      </Route>
      {/* お届け先追加  */}
      <Route path="/mypage/address/add">
        <AddressAdd />
      </Route>
      {/* PW  */}
      <Route path="/mypage/update_password">
        <UpdatePW />
      </Route>
      {/* PW  */}
      <Route path="/reset_password">
        <ResetPW />
      </Route>
      {/* カート  */}
      <Route path="/cart">
        <Cart />
      </Route>
      {/* お申し込み  */}
      <Route path="/apply" exact>
        <Apply />
      </Route>
      {/* About  */}
      <Route path="/about">
        <About />
      </Route>
      {/* ご購入流れ  */}
      <Route path="/purchase">
        <Purchase />
      </Route>
      {/* 商品特長  */}
      <Route path="/features">
        <Features />
      </Route>
      {/* ニュース  */}
      <Route exact path="/news">
        <News />
      </Route>
      {/* ニュース詳細  */}
      <Route path="/news/:id">
        <NewsDetails />
      </Route>
      {/* TESTSHOP  */}
      <Route path="/testshop">
        <Testshop />
      </Route>
      {/* FAQ  */}
      <Route path="/faq">
        <Faq />
      </Route>
      {/* Master Card  */}
      <Route path="/update-card">
        <MasterCard />
      </Route>
      {/* Interview Introduction Detail  */}
      <Route exact path="/interview_01">
        <Interview01 />
      </Route>
      <Route exact path="/interview_02">
        <Interview02 />
      </Route>
      <Route exact path="/interview_03">
        <Interview03 />
      </Route>
      <Route exact path="/interview_04">
        <Interview04 />
      </Route>
      {/* Top  */}
      <Route path="/">
        <HomePage />
      </Route>
    </Switch>
  </BrowserRouter>
);

export default Routes;
